
export default {
  namespaced: true,
  state: {
    pageTitle: '',
    breadcrumbList: [],
    pageError: null
  },
  mutations: {
    // Update current page title
    setPageTitle (state, title) {
      state.pageTitle = title
      document.title = state.pageTitle + " - Synergy Software Pty Ltd"
    },
    setPageBreadcrumbs(state, breadcrumbList) {
      state.breadcrumbList = breadcrumbList
    },
    setPageError(state, pageErrorDetails) {
      state.pageError = pageErrorDetails 
    }
  }
}
